import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import ProjectedEarningsPage from '../components/ProjectedEarningsPage'
import {
  actionCreators,
  IProjectedEarningsState,
  selectError,
  selectFilterText,
  selectIsLoading,
  selectItems,
  selectTotalItems,
} from '../modules/projectedEarnings'

export default connect(
  createStructuredSelector<ApplicationState, IProjectedEarningsState>({
    error: selectError(),
    filterText: selectFilterText(),
    isLoading: selectIsLoading(),
    items: selectItems(),
    totalItems: selectTotalItems(),
  }),
  actionCreators,
)(ProjectedEarningsPage)
